import {
  Required,
  DataValidator,
  transformKeys,
  IsString,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

interface AgentV2OrderStatsResponse {
  total_order_count: number,
  completed_order_count: number,
  total_amount: number
}

export class AgentV2OrderStatsData {
  @Required("total_order_count cannot be empty")
  @IsNumber("total_order_count must be a number")
  totalOrderCount: number;

  @Required("completed_order_count cannot be empty")
  @IsNumber("completed_order_count must be a number")
  completedOrderCount: number;

  @Required("total_amount cannot be empty")
  @IsNumber("total_amount must be a number")
  totalAmount: number;
}

const transformAndValidateData = (
  response: AgentV2OrderStatsResponse
): AgentV2OrderStatsData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentV2OrderStatsData);
  } catch (error) {
    console.error("Agent v2 order stats data validation failed:", error.message);
    throw error;
  }
};

/** 订单管理-聚合统计(总订单数/未完成订单数/总交易额) */
export const agentV2OrderStats = async (agentId: string) => {
  const res = await api.post<AgentV2OrderStatsResponse>('/agent-v2/order-stats', {
    agent_id: agentId,
  });
  const data = transformAndValidateData(res.data);
  return data;
}